import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    email_sendCodeVerification({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/send-code-verification', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    email_verifyCode({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/verify-code', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    email_setDni({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/set-dni', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    email_storeMessage({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/store-message', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    email_sendPassword({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/send-password', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    email_sendMany({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'email/send-many', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};